import { FC, SubmitEvent, useState } from 'react';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { houseToHouseServices } from 'src/services';
import { HTHForm } from './commons/HTHForm';
import { typeDoNotCall, typeHTHFace, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetCurrentUser } from 'src/custom-hooks';

type propsType = {
    closeShowFormHandler: () => void;
    currentFace: typeHTHFace;
    territoryNumber: typeTerritoryNumber;
};

export const HTHDoNotCallsForm: FC<propsType> = ({ closeShowFormHandler, currentFace, territoryNumber }) => {
    const [doorBell, setDoorBell] = useState("");
    const [streetNumber, setStreetNumber] = useState(0);
    const date = generalHelpers.GetCurrentLocalDate();
    const dispatch = useDispatch();
    const user = useGetCurrentUser();

    const submitHandler = async (e: SubmitEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();
        if (!user || streetNumber < 1) {
            return;
        }
        const newDoNotCall: typeDoNotCall = {
            creatorId: user.id,
            date,
            doorBell: doorBell.trim(),
            id: 0,
            streetNumber
        };
        dispatch(showLoadingModalReducer());
        const response = await houseToHouseServices.AddDoNotCall(territoryNumber, currentFace.block, currentFace.face, currentFace.id, newDoNotCall);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        closeShowFormHandler();
        setStreetNumber(0);
        setDoorBell('');
    }

    const cancelFormHandler = (): void => {
        closeShowFormHandler();
        setStreetNumber(0);
        setDoorBell('');
    }

    const setDoorBellHandler = (_doorBell: string): void => setDoorBell(_doorBell);

    const setStreetNumberHandler = (_streetNumber: number): void => setStreetNumber(_streetNumber);

    return (
        <HTHForm
            cancelFormHandler={cancelFormHandler}
            currentFace={currentFace}
            isDoNotCallForm={true}
            submitHandler={submitHandler}
            territoryNumber={territoryNumber}
            date={date}
            doorBell={doorBell}
            setDoorBellHandler={setDoorBellHandler}
            setStreetNumberHandler={setStreetNumberHandler}
            streetNumber={streetNumber}
        />
    );
}
